const DATE_FORMAT = "dd.MM.yy" as const;

const DESKTOP_WIDTH_BREAKPOINT = 991 as const;

export { DATE_FORMAT, DESKTOP_WIDTH_BREAKPOINT };
